// Build a relative return URL from a location-like object.
export const makeReturnUrl = (location) => {
  if (!location) return '';
  const path = location.pathname || '/';
  const search = location.search || '';
  const hash = location.hash || '';
  return `${path}${search}${hash}`;
};

// Safely build the register path with an optional returnUrl override.
export const buildRegisterLink = (location, { returnUrlOverride, extraParams } = {}) => {
  const params = new URLSearchParams(extraParams || {});
  const returnUrl = returnUrlOverride || makeReturnUrl(location);
  if (returnUrl) {
    params.set('returnUrl', returnUrl);
  }
  const qs = params.toString();
  return qs ? `/register?${qs}` : '/register';
};

// Ensure a returnUrl resolves to the current origin and return a relative path.
export const getSafeReturnPath = (rawUrl) => {
  if (!rawUrl) return '';
  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : undefined;
    const resolved = new URL(rawUrl, origin || 'http://localhost');
    if (origin && resolved.origin !== origin) return '';
    return `${resolved.pathname || '/'}${resolved.search || ''}${resolved.hash || ''}`;
  } catch {
    return '';
  }
};

// Append or replace a query param on a path-ish string.
export const addQueryParam = (path, key, value) => {
  if (!path || !key) return path;
  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const url = new URL(path, origin);
    if (value === undefined || value === null || value === '') {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return path;
  }
};
